"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)({
  boxImage: {
    width: 240,
    height: '100%',
    border: 'none',
    '& > img': {
      borderRadius: 5
    }
  }
});

var GiftVideoVidyardDetails = function GiftVideoVidyardDetails(_ref) {
  var thumbnail = _ref.thumbnail;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2,
    className: classes.boxImage
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: "100%",
    alt: "video preview",
    src: thumbnail
  }));
};

GiftVideoVidyardDetails.propTypes = {
  thumbnail: _propTypes.default.string.isRequired
};
var _default = GiftVideoVidyardDetails;
exports.default = _default;